import { useEffect } from 'react';
import imageSamplePhotobook from '../../assets/images/sample-photobook.png';
import imageSampleCanvas from '../../assets/images/sample-canvas.png';

declare global {
  interface Window {
    loadProjectThumbnail: (
      projectId: string,
      userMediaclipToken: string,
      elementId: string,
      defaultImage: string,
    ) => string;
  }
}

export type PreviewProps = {
  projectId: string;
  userMediaclipToken: string;
  category: string;
};

const Preview = (props: PreviewProps) => {
  useEffect(() => {
    loadProjectThumbnail();
  }, []);

  const categoryImage: {
    [index: string]: string;
  } = {
    photobook: imageSamplePhotobook,
    canvas: imageSampleCanvas,
  };

  const categoryText: {
    [index: string]: string;
  } = {
    photobook: '* sample photobook',
    canvas: '* sample canvas',
  };

  const loadProjectThumbnail = () => {
    console.log('Loading thumbnail for project id: ' + props.projectId);
    if (props.projectId && props.userMediaclipToken) {
      window.loadProjectThumbnail(
        props.projectId,
        props.userMediaclipToken,
        'preview-image',
        categoryImage[props.category],
      );
    }
  };

  return (
    <div id="preview-image">
      <img></img>
      <p className="text-preview-error">{categoryText[props.category]}</p>
    </div>
  );
};

export default Preview;
